import { HStack, Button } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TABS = [
  { to: '/library', key: 'playlists', end: true },
  { to: '/library/clips', key: 'clips', end: false },
];

/** Sub-navigation shared by the Library pages (Playlists / Audio clips). */
export function LibraryTabs() {
  const { t } = useTranslation();
  return (
    <HStack spacing={2} mb={5}>
      {TABS.map((tab) => (
        <Button
          key={tab.to}
          as={NavLink}
          to={tab.to}
          end={tab.end}
          size="sm"
          variant="ghost"
          borderRadius="full"
          color="gray.600"
          _activeLink={{ bg: 'brand.50', color: 'brand.700' }}
        >
          {t(`library.tabs.${tab.key}`)}
        </Button>
      ))}
    </HStack>
  );
}

export default LibraryTabs;
